import { ServiceProvider } from "Service";
import { IBaseGrid, IFilter } from "Grids/Interfaces";
import { Page } from "./Page";
import { Mapping, AppContext } from "Core";
import { GridTypes, MappingDisplayTypes } from "Service/Client";
import CancellationToken from "cancellationtoken";

export class MappingPage extends Page {
    public mapping: Mapping;
    private additionalMappings: Mapping[] = [];

    private dmsView: kendo.View;

    constructor(public mappingName: string, serviceProvider: ServiceProvider) {
        super(serviceProvider);
    }

    public canNavigate(): boolean {
        for (const grid of this.getGrids()) {
            if (!grid.canNavigate()) {
                return false;
            }
        }
        return true;
    }

    async render(layout: kendo.Layout, cancellationToken: CancellationToken): Promise<void> {
        await this.initialize(this.mappingName);
        $(".dms-content-wrapper").css("visibility", "hidden");

        if (cancellationToken.isCancelled) {
            return;
        }

        let dmsModel = kendo.observable({ mappingName: this.mappingName });

        this.dmsView = new kendo.View(`<div class="#= mappingName # dms-mapping-wrapper"></div>`, {
            model: dmsModel,
            evalTemplate: true,
            wrap: false,
            show: () => {
                this.initializeMapping(cancellationToken).then(() => {
                    if (cancellationToken.isCancelled) {
                        return;
                    }
                    this.resize();
                    $(".dms-content-wrapper").css("visibility", "visible");

                    // CoreContext.Instance.resizePage();
                    // $(".dms-content-wrapper").addClass("animate__fadeIn animate__faster");

                    // setTimeout(() => $(".dms-content-wrapper").removeClass("animate__fadeIn animate__faster"), 5000);
                });
            },
            hide: () => {},
        });

        if (cancellationToken.isCancelled) {
            return;
        }
        await super.render(layout, cancellationToken);

        if (cancellationToken.isCancelled) {
            return;
        }
        layout.containers = {};
        layout.showIn(".dms-content-container", this.dmsView);
    }

    /**
     * Initializes a mapping on this page.
     * @param mappingName Name of the mapping.
     * @hidden
     */
    public async initializeMapping(
        cancellationToken: CancellationToken,
        displayType: MappingDisplayTypes = MappingDisplayTypes.FilterAndGrids
    ): Promise<void> {
        this.mapping = new Mapping(
            this.mappingName,
            this.currentTextBlockCategory,
            this.serviceProvider,
            Promise.resolve(),
            AppContext.current.environment
        );
        this.serviceProvider.TextBlock.getAll().then(() => {
            this.resize();
        });
        await this.mapping.initialize($(".dms-mapping-wrapper." + this.mappingName), displayType, cancellationToken);

        if (AppContext.current.environment.AutoCreateTextBlocksIfMissing) {
            setTimeout(() => {
                if (cancellationToken.isCancelled) {
                    return;
                }
                this.serviceProvider.TextBlock.setTextBlocks(AppContext.current.environment.LanguageCode);
            }, 2000);
        }
    }

    /**
     * Initialize a mapping in given container.
     * @param container The container in which the mapping will be initialized.
     * @param mappingName Name of the mapping to be initialized. The TextBlocks for the mapping are loaded.
     * @param displayType Specify if both filters and grids should be shown or just one of them.
     * @hidden
     */
    public async initializeMappingInContainer(
        container: JQuery,
        mappingName: string,
        displayType: MappingDisplayTypes = MappingDisplayTypes.FilterAndGrids
    ): Promise<Mapping> {
        await this.serviceProvider.TextBlock.load(AppContext.current.environment.LanguageCode, mappingName);

        let mapping = new Mapping(mappingName, mappingName, this.serviceProvider, Promise.resolve(), AppContext.current.environment);
        this.additionalMappings.push(mapping);
        await mapping.initialize(container, displayType, null);

        if (AppContext.current.environment.AutoCreateTextBlocksIfMissing) {
            setTimeout(() => this.serviceProvider.TextBlock.setTextBlocks(AppContext.current.environment.LanguageCode), 2000);
        }
        return mapping;
    }

    public getMappings(): Mapping[] {
        let mappings: Mapping[] = [];
        if (this.mapping) {
            mappings.push(this.mapping);
        }
        // if (this.menuMapping) {
        //     mappings.push(this.menuMapping);
        // }
        mappings = mappings.concat(this.additionalMappings);
        return mappings;
    }

    /**
     * Get first Filter
     * @hidden
     */
    public getFilter(): IBaseGrid {
        let mappings = this.getMappings();
        for (let i = 0, len = mappings.length; i < len; i++) {
            let grids = mappings[i].getGrids();
            for (let j = 0, gridLen = grids.length; j < gridLen; j++) {
                if (grids[j].getGridType() == GridTypes.Filter) {
                    return grids[j];
                }
            }
        }
        return null;
    }

    /**
     * Reloads all grids on the current page.
     * @hidden
     */
    public reloadGrids(reloadFilters: boolean) {
        let grids = this.getGrids();
        for (let i = 0, len = grids.length; i < len; i++) {
            let grid = grids[i];
            if (grid.getGridType() != GridTypes.Filter || reloadFilters) {
                grid.reload();
            }
        }
    }

    /**
     * Hides all registered grids.
     * @param clearGrid - True if the grids should be cleared aswell.
     * @hidden
     */
    public hideGrids(clearGrid: boolean = true): void {
        if (this.mapping) {
            let grids = this.mapping.getGrids();
            for (let i = 0, len = grids.length; i < len; i++) {
                let grid = grids[i];
                if (grid.getGridType() != GridTypes.Filter) {
                    grid.hide();
                    if (clearGrid) {
                        grid.clear();
                    }
                }
            }
        }
    }

    /**
     * Get all grids registered on CoreContext.
     * @hidden
     */
    public getGrids(): IBaseGrid[] {
        let mappings = this.getMappings();
        let grids: IBaseGrid[] = [];
        for (let i = 0, len = mappings.length; i < len; i++) {
            grids = grids.concat(mappings[i].getGrids());
        }
        // if (this.menuMapping) {
        //     grids = grids.concat(this.menuMapping.getGrids());
        // }
        return grids;
    }

    public removeAdditionalMapping(mapping: Mapping): void {
        let idx = this.additionalMappings.indexOf(mapping);
        if (idx > -1) {
            this.additionalMappings.splice(idx, 1);
        }
    }

    /**
     * Calculate the available height for the content area.
     * @hidden
     */
    public getAvailableHeight(): number {
        let positionTop = 0;
        let windowHeight = $(window).height();

        positionTop = $(".dms-content-wrapper").offset().top;
        positionTop += $(".dms-content-header").outerHeight();

        if (this.mapping && this.mapping.getGrids().length > 0) {
            positionTop = this.mapping.getGrids()[0].getOuterElement().offset().top;
        }
        return windowHeight - positionTop;
    }

    /**
     * Resizes Grids which have no height defined.
     * @hidden
     */
    public resize(): void {
        let availableHeight = this.getAvailableHeight();
        if (this.mapping) {
            this.mapping.setHeight(availableHeight);
        }
    }

    /**
     * @hidden
     */
    public getFilterParameters(): { [key: string]: any } {
        let filterparams: { [key: string]: any } = {};
        let grids = this.getGrids();
        for (let i = 0, len = grids.length; i < len; i++) {
            let grid = grids[i];
            if (grid.getGridType() == GridTypes.Filter) {
                let filter = <IFilter>grid;
                if (filter.getData) {
                    let filterdata = filter.getData();
                    filterparams = $.extend(filterparams, filterparams, filterdata);
                }
            }
        }
        return filterparams;
    }

    dispose(): void {
        super.dispose();

        if (this.mapping) {
            this.mapping.dispose();
        }
        if (this.additionalMappings) {
            for (const mapping of this.additionalMappings) {
                mapping.dispose();
            }
        }

        if (this.dmsView) {
            this.dmsView.destroy();
        }
    }
}
